<template>
  <div>
    <hr />
    <div class="mb-3">
      <table class="tablaBusqueda">
        <tbody>
          <tr>
            <td>
              <button
                v-if="!cargaActivaSinArchivos && p_numSemana + 1 <= p_maxSemana"
                type="submit"
                class="btn btn-success"
                data-bs-toggle="modal"
                data-bs-target="#ventanaModal"
                @click="abrirModalCrear"
                title="Nuevo registro"
              >
                <i
                  class="material-icons"
                  style="font-size: 24px; cursor: pointer"
                  >upload_file</i
                >Cargar semana {{ p_numSemana + 1 }}
              </button>
              <button
                v-if="p_idAutorizacion > 0"
                type="submit"
                class="btn btn-success"
                data-bs-toggle="modal"
                data-bs-target="#ventanaModal"
                @click="abrirModalCrear"
                title="Nuevo registro"
              >
                <i
                  class="material-icons"
                  style="font-size: 24px; cursor: pointer"
                  >upload_file</i
                >Cargar
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col">Fecha desde</th>
          <th scope="col">Fecha hasta</th>
          <th scope="col">Registros</th>
          <th scope="col">Errores</th>
          <th scope="col"></th>
          <th scope="col">Opciones</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="carga in datosPaginados"
          :key="carga.idCarga"
          @dblclick="handleRowClick($event, carga.idCarga)"
        >
          <td>{{ getFormattedDate(carga.fechaDesde, "DD/MM/YYYY") }}</td>
          <td>{{ getFormattedDate(carga.fechaHasta, "DD/MM/YYYY") }}</td>
          <td>{{ carga.numeroRegistros }}</td>
          <td>{{ carga.tieneErrores === 1 ? "Sí" : "No" }}</td>
          <td>
            <button
              v-if="carga.tieneErrores === 0 && carga.tienePlanillas === 0"
              type="submit"
              class="btn btn-success"
              @click.prevent="generarAtenciones(carga.idCarga)"
              title="Organizar Atenciones Médicas"
            >
              <span class="material-symbols-outlined">settings</span>
              Organizar Atenciones Médicas
            </button>
            <button
              v-if="carga.tieneErrores === 1 && carga.estado === 1"
              type="submit"
              class="btn btn-danger"
              @click.prevent="borrarCarga(carga.idCarga)"
              title="Borrar Carga"
            >
              <span class="material-symbols-outlined">close</span>
              Borrar Carga
            </button>
            <button
              v-if="carga.tienePlanillas === 1 && carga.tieneArchivos === 0"
              type="button"
              class="btn btn-success"
              @click.prevent="abrirModalArchivos(carga.idCarga)"
              title="Carga de Archivos"
            >
              <span
                class="material-symbols-outlined"
                style="font-size: 24px; cursor: pointer"
                >drive_folder_upload</span
              >
              Carga de Archivos
            </button>
            <p
              class="text-danger"
              v-if="carga.tieneErrores === 1 && carga.estado === 0"
            >
              Carga borrada
            </p>
          </td>
          <td>
            <select
              class="form-select form-select-sm"
              @change="
                handleAction(
                  $event,
                  carga.idCarga,
                  getFormattedDate(carga.fechaDesde, 'DD/MM/YYYY'),
                  getFormattedDate(carga.fechaHasta, 'DD/MM/YYYY')
                )
              "
            >
              <option disabled selected>Seleccione...</option>
              <option value="resumen">Resumen</option>
              <option v-if="carga.tieneErrores === 1" value="observaciones">
                Observaciones
              </option>
              <!--			  
              <option v-if="carga.estado === 1" value="detalles">
                Detalle de Atenciones
              </option>
-->
            </select>
          </td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()">
          <a class="page-link" href="#">Anterior</a>
        </li>
        <li
          id="lugar"
          v-for="pagina in totalPaginas()"
          v-bind:key="pagina"
          v-on:click="getDataPaginaTodos(pagina)"
          class="page-item"
          v-bind:class="isActive(pagina)"
        >
          <a class="page-link" href="#">{{ pagina }}</a>
        </li>
        <li class="page-item" v-on:click="getNextPage()">
          <a class="page-link" href="#">Siguiente</a>
        </li>
      </ul>
    </nav>
    <!-- Modal -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title" id="exampleModalLabel">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div v-if="opcionModal === 'crear'">
            <div class="modal-body">
              <hr />
              <!-- Cargar archivo de datos -->
              <div class="upload-container">
                <!-- Texto introductorio -->
                <div class="mb-3">
                  <p>
                    Esta funcionalidad permite cargar desde un archivo
                    <b>JSON</b>, con el formato establecido, los datos
                    correspondientes a las atenciones médicas asociadas al
                    trámite. Asegúrate de que el archivo cumpla con las
                    especificaciones requeridas antes de cargarlo.
                  </p>
                </div>

                <!-- Formulario de carga -->
                <form @submit.prevent="uploadFile">
                  <div class="row align-items-center">
                    <div class="col-3">
                      <label for="archivoDatos"
                        ><b>Seleccionar Archivo de datos:</b></label
                      >
                    </div>
                    <div class="col-6">
                      <input
                        type="file"
                        id="archivoDatos"
                        name="archivoDatos"
                        class="form-control"
                        @change="handleFileUpload"
                        accept=".json"
                        required
                        aria-describedby="archivoDatosHelp"
                      />
                      <small id="archivoDatosHelp" class="form-text text-muted">
                        Selecciona un archivo JSON con los datos a cargar.
                      </small>
                    </div>
                    <div class="col-3 text-end">
                      <button
                        type="submit"
                        class="btn btn-outline-success d-flex align-items-center"
                      >
                        <span
                          class="material-symbols-outlined"
                          style="font-size: 32px; cursor: pointer"
                          >upload_file</span
                        >
                        <span class="ms-2"><b>Cargar archivo de datos</b></span>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <hr />
          </div>
          <div v-if="opcionModal === 'resumen'">
            <form>
              <div class="modal-body">
                <div class="mb-1">
                  <div class="row">
                    <div class="col-2">
                      <label class="form-label fw-bold">IdCarga</label>
                    </div>
                    <div class="col-2">
                      <span>{{ datoCarga.idCarga }}</span>
                    </div>
                    <div class="col-2">
                      <label class="form-label fw-bold">Tamaño Archivo</label>
                    </div>
                    <div class="col-2">
                      <span>{{ datoCarga.tamanioArchivo }}</span>
                    </div>
                  </div>
                </div>

                <div class="mb-1">
                  <div class="row">
                    <div class="col-2">
                      <label class="form-label fw-bold">Número Registros</label>
                    </div>
                    <div class="col-2">
                      <span>{{ datoCarga.numeroRegistros }}</span>
                    </div>
                    <div class="col-2">
                      <label class="form-label fw-bold">Fecha Desde</label>
                    </div>
                    <div class="col-2">
                      <span>{{ getFormattedDate(datoCarga.fechaDesde) }}</span>
                    </div>
                    <div class="col-2">
                      <label class="form-label fw-bold">Fecha Hasta</label>
                    </div>
                    <div class="col-2">
                      <span>{{ getFormattedDate(datoCarga.fechaHasta) }}</span>
                    </div>
                  </div>
                </div>

                <div class="mb-1">
                  <div class="row">
                    <div class="col-2">
                      <label class="form-label fw-bold">Nombre Archivo</label>
                    </div>
                    <div class="col-10">
                      <span>{{ datoCarga.nombreArchivo }}</span>
                    </div>
                  </div>
                </div>

                <div class="mb-1">
                  <div class="row">
                    <div class="col-2">
                      <label class="form-label fw-bold">Observaciones</label>
                    </div>
                    <div class="col-10">
                      <span>{{ datoCarga.obs }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div v-if="opcionModal === 'archivos'">
            <hr />
            <!-- Cargar archivos de planillas -->
            <div class="upload-container">
              <!-- Texto introductorio -->
              <div class="mb-3">
                <p>
                  Esta funcionalidad permite cargar los archivos relacionados
                  con planillas en el sistema. Asegúrate de seleccionar los
                  archivos necesarios y que cumplan con el formato requerido
                  antes de proceder con la carga.
                </p>
              </div>

              <!-- Formulario de carga -->
              <form @submit.prevent="uploadFiles">
                <div class="row align-items-center">
                  <div class="col-3">
                    <label for="archivosPlanillas"
                      ><b>Seleccionar Archivos de planillas:</b></label
                    >
                  </div>
                  <div class="col-6">
                    <input
                      type="file"
                      id="archivosPlanillas"
                      name="archivosPlanillas"
                      class="form-control"
                      @change="handleFilesUpload"
                      accept=".pdf"
                      webkitdirectory
                      directory
                      multiple
                      required
                      aria-describedby="archivosPlanillasHelp"
                    />
                    <small
                      id="archivosPlanillasHelp"
                      class="form-text text-muted"
                    >
                      Selecciona uno o más archivos relacionados con las
                      planillas a cargar.
                    </small>
                  </div>
                  <div class="col-3 text-end">
                    <button
                      type="submit"
                      class="btn btn-outline-success d-flex align-items-center"
                      :disabled="
                        archivosPlanillas.length == 0 ||
                        archivosPlanillas.length > 10
                      "
                    >
                      <span
                        class="material-symbols-outlined"
                        style="font-size: 32px; cursor: pointer"
                        >upload_file</span
                      >
                      <span class="ms-2"
                        ><b>Cargar archivos de planillas</b></span
                      >
                    </button>
                  </div>
                </div>
              </form>
            </div>
            <hr />
            <p class="text-success fw-bold text-center">
              Archivos seleccionados: {{ archivosPlanillas.length }}
            </p>
            <p
              v-if="archivosPlanillas.length > 10"
              class="text-danger fw-bold text-center"
            >
              Debes seleccionar entre 1 y 10 archivos.<br />
              Divide la carga en {{ archivosPlanillas.length / 10 }} bloques
            </p>
            <br />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/services/api";
import dateFormat from "@/modules/dateFormat.js";

import * as $ from "jquery";
import Swal from "sweetalert2";
window["$"] = $;
window["jQuery"] = $;
import swal from "sweetalert";
export default {
  props: {
    p_idTramite: {
      type: Number,
      required: true,
    },
    p_idAutorizacion: {
      type: Number,
      required: true,
    },
    p_numSemana: {
      type: Number,
      required: true,
    },
    p_maxSemana: {
      type: Number,
      required: true,
    },
    p_fechaDesde: {
      type: Date,
      required: true,
    },
  },
  data() {
    return {
      cargas: [],
      datoCarga: {},
      nombreBusqueda: "",
      titulo: "",
      opcionModal: "",
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      tramites: [],
      p_idUsuario: 0,
      archivoDatos: null, // Archivo CSV seleccionado
      archivosPlanillas: [], // Arreglo para múltiples archivos
      idCargaSeleccionada: 0,
      cargaActivaSinArchivos: false,
    };
  },
  async mounted() {
//alert("this.p_idAutorizacion 2: "+this.p_idAutorizacion);	  
    this.p_idUsuario = window.sessionStorage.getItem("idUsuario");
    await this.getDataPaginaTodos(this.paginaActual);
    await this.obtenerMaxSemanas();
//	alert("CONTROL: "+this.p_maxSemana);
  },
  methods: {
    handleRowClick(event, idCarga) {
      if (
        event.target.tagName === "SELECT" ||
        event.target.tagName === "OPTION"
      ) {
        return;
      }
      this.abrirModalEditar(idCarga);
    },
    handleAction(event, idCarga, fechaDesde, fechaHasta) {
      const action = event.target.value;
      if (action === "resumen") {
        this.abrirModalEditar(idCarga, fechaDesde, fechaHasta);
      } else if (action === "observaciones") {
        this.abrirObservaciones(idCarga);
        /*		
      } else if (action === "detalles") {
        this.abrirEditar(idCarga);
*/
      }
      event.target.value = "Seleccione...";
    },
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas() {
      return Math.ceil(this.cargas.length / this.elementosPorPagina);
    },
    getDataPaginaTodos(noPagina) {
      api.get("/vwcargas/idtramite/" + this.p_idTramite
        )
        .then((response) => {
          this.cargas = response.data.reverse();
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini =
            noPagina * this.elementosPorPagina - this.elementosPorPagina;
          let fin = noPagina * this.elementosPorPagina;
          this.datosPaginados = this.cargas.slice(ini, fin);
        });
      this.verificarCargasActivas();
    },
    getPreviousPage() {
      if (this.paginaActual > 1) {
        this.paginaActual--;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) {
        this.paginaActual++;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    isActive(noPagina) {
      return noPagina == this.paginaActual ? "active" : "";
    },
    abrirModalCrear() {
      this.modalWindow = true;
      this.datoCarga = {};
      this.titulo = "Carga de Archivo de Datos";
      this.opcionModal = "crear";
    },
    abrirModalEditar(idCarga, fechaDesde, fechaHasta) {
      this.modalWindow = true;
      if (idCarga != null) {
        api.get("/vwcargas/" + idCarga)
          .then((resp) => {
            this.datoCarga = resp.data;
          });
      }
      $("#ventanaModal").modal("show");
      this.titulo =
        "Resumen de la Carga: semana desde " +
        fechaDesde +
        " hasta " +
        fechaHasta;
      this.opcionModal = "resumen";
    },
    abrirModalArchivos(idCarga) {
      this.modalWindow = true;
      $("#ventanaModal").modal("show");
      this.titulo = "Carga de archivos de planillas";
      this.opcionModal = "archivos";
      this.idCargaSeleccionada = idCarga;
    },
    abrirObservaciones(idCarga) {
      if (idCarga != null) {
        this.$router.push(
          "/cargaplanillaobs/" + this.p_idTramite + "/" + idCarga
        );
      }
    },
    /*	
    abrirEditar(idCarga) {
      if (idCarga != null) {
        this.$router.push("/cargaplanilla/" + this.p_idTramite + "/" + idCarga);
      }
    },
*/
    // Captura el archivo seleccionado para archivoDatos
    handleFileUpload(event) {
      this.archivoDatos = event.target.files[0];
    },
    // Enviar archivoDatos al servidor
    async uploadFile() {
      if (!this.archivoDatos) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No se ha seleccionado ningún archivo para cargar.",
          showConfirmButton: true,
        });
        return;
      }

      // Obtener la fecha de modificación del archivo
      const fechaModificacion = this.archivoDatos.lastModified; // Timestamp en milisegundos

      const formData = new FormData();
      formData.append("idTramite", this.p_idTramite);
      formData.append("idAutorizacion", this.p_idAutorizacion);
      formData.append("idUsuario", this.p_idUsuario);
      formData.append("fechaModificacion", fechaModificacion);
      formData.append("file", this.archivoDatos);

      try {
        Swal.fire({
          title: "Procesando...",
          text: "Por favor, espera mientras se cargan los datos del archivo.",
          allowOutsideClick: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading(); // Muestra el indicador de carga
          },
        });
        const response = await api.post(`/cargaplanillas/cargar-archivo`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        Swal.close();
        const icono =
          response.data.contadorErrores === 0 ? "success" : "warning";
        await Swal.fire({
          icon: icono,
          title: "Archivo cargado",
          html: response.data.mensaje,
          showConfirmButton: true,
        }).then(() => {
          // Este bloque se ejecuta después de que el usuario presiona "OK"
          // Limpiar el input y el estado
          this.archivoDatos = null;
          document.getElementById("archivoDatos").value = "";
          // Recargar la página
          //          window.location.reload();
        });
        $("#ventanaModal").modal("hide");
        this.getDataPaginaTodos(this.paginaActual);
      } catch (error) {
        const errorMessage =
          error.response?.data?.message ||
          error.response?.data?.error ||
          "Error desconocido";
        await Swal.fire({
          icon: "error",
          title: "Error",
          html: `Hubo un error al cargar los archivos. Inténtalo de nuevo. <br><strong>${errorMessage}</strong>`,
          showConfirmButton: true,
        }).then(() => {
          // Recargar la página después de cerrar el alert
          window.location.reload();
        });
      }
    },
    async generarAtenciones(idCarga) {
      try {
        await api.post("/cargaplanillas/generar-planillas",
          null,
          {
            params: {
              idTramite: this.p_idTramite,
              idCarga: idCarga,
              idUsuario: this.p_idUsuario,
            },
          }
        );
        swal("Correcto!", "Atenciones generadas exitosamente!", "success");
        this.getDataPaginaTodos(this.paginaActual);
        this.$emit("estadoTramite", "ESTRUCTURADO");
      } catch (error) {
        swal("Error!", "Intentelo de nuevo!", "error");
      }
    },
    async borrarCarga(idCarga) {
      try {
        await api.post("/cargas/eliminar", null, {
          params: {
            idTramite: this.p_idTramite,
            idCarga: idCarga,
            idUsuario: this.p_idUsuario,
          },
        });
        swal("Correcto!", "Carga eliminada exitosamente!", "success");
        this.getDataPaginaTodos(this.paginaActual);
        this.$emit("actualizarTramite", true);
      } catch (error) {
        swal("Error!", "Intentelo de nuevo!", "error");
      }
    },
    // Captura los archivos seleccionados para archivosPlanillas
    handleFilesUpload(event) {
      this.archivosPlanillas = event.target.files;
    },
    // Enviar archivosPlanillas al servidor
    async uploadFiles() {
      if (!this.archivosPlanillas || this.archivosPlanillas.length === 0) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No se han seleccionado archivos para cargar.",
          showConfirmButton: true,
        });
        return;
      }

      const formData = new FormData();
      formData.append("idTramite", this.p_idTramite);
      formData.append("idCarga", this.idCargaSeleccionada);
      formData.append("idUsuario", window.sessionStorage.getItem("idUsuario"));

      // Verificar archivos antes de agregarlos
      for (let i = 0; i < this.archivosPlanillas.length; i++) {
        const archivo = this.archivosPlanillas[i];

        if (!this.verificarArchivo(archivo)) {
          Swal.fire({
            icon: "warning",
            title: "Archivo no permitido",
            html: `El archivo <b>${archivo.name}</b> excede el tamaño permitido o tiene un formato incorrecto.`,
            showConfirmButton: true,
          });
          return; // Detener la subida si algún archivo no es válido
        }

        formData.append("archivos", archivo);
      }
      try {
        const response = await api.post("/archivospla/indexar-directorio-carga",
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        await this.manejarRespuesta(response.data);
        $("#ventanaModal").modal("hide");
        this.getDataPaginaTodos(this.paginaActual);
        window.location.reload();
      } catch (error) {
        console.error("Error con Axios:", error);
      }
    },
    async manejarRespuesta(data) {
      if (data.archivosCargados?.length > 0) {
        await Swal.fire({
          icon: "success",
          title: "Archivos cargados correctamente",
          html: `Se han cargado <b>${data.archivosCargados.length}</b> archivos.`,
          showConfirmButton: true,
        });
      }

      if (data.archivosDuplicados?.length > 0) {
        await Swal.fire({
          icon: "warning",
          title: "Archivos duplicados",
          html: `Se han encontrado <b>${data.archivosDuplicados.length}</b> archivos duplicados.`,
          showConfirmButton: true,
        });
      }

      if (data.planillasNoEncontradas?.length > 0) {
        await Swal.fire({
          icon: "error",
          title: "Planillas no encontradas",
          html: `<b>${data.planillasNoEncontradas.length}</b> planillas no encontradas.`,
          showConfirmButton: true,
        });
      }

      if (data.archivosCargados.length > 0)
        this.descargarCSV(data.archivosCargados, "archivosCargados.csv");
      if (data.archivosDuplicados.length > 0)
        this.descargarCSV(data.archivosDuplicados, "archivosDuplicados.csv");
      if (data.planillasNoEncontradas.length > 0)
        this.descargarCSV(
          data.planillasNoEncontradas,
          "planillasNoEncontradas.csv"
        );

      console.log("Archivo subido con éxito", data);
    },
    descargarCSV(data, nombreArchivo) {
      if (!data || data.length === 0) {
        alert("No hay datos para exportar.");
        return;
      }

      // Encabezado del CSV
      let csvContent = "data:text/csv;charset=utf-8,Nombre de archivo\n";

      // Agregar cada archivo como una línea en el CSV
      data.forEach((archivo) => {
        csvContent += archivo + "\n";
      });

      // Crear un enlace de descarga
      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", nombreArchivo || "archivos_cargados.csv"); // Usa el nombre dado o el predeterminado

      // Agregar al DOM y hacer clic automáticamente
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    verificarArchivo(archivo) {
      const tiposPermitidos = ["application/pdf", "image/jpeg", "image/png"];
      const tamañoMaximo = 1 * 1024 * 1024; // 5MB

      if (!tiposPermitidos.includes(archivo.type)) {
        console.error(`Archivo ${archivo.name} tiene un tipo no permitido.`);
        return false;
      }

      if (archivo.size > tamañoMaximo) {
        console.error(
          `Archivo ${archivo.name} excede el tamaño máximo permitido.`
        );
        return false;
      }

      return true;
    },
    async verificarCargasActivas() {
      if (!this.p_idTramite) {
        alert("Ingrese un ID de trámite válido");
        return;
      }

      try {
        const response = await api.get(`/vwcargas/tramite/${this.p_idTramite}/cargas-activas-sin-archivos`
        );
        this.cargaActivaSinArchivos = response.data; // Almacena la respuesta (true o false)
      } catch (error) {
        console.error("Error al consultar el servicio:", error);
        alert("Ocurrió un error al consultar el servicio.");
      }
    },
  },
};
</script>
<style scoped>
.upload-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 90%;
  margin: 10px auto;
  padding: 15px;
  border: 2px solid #ccc;
  border-radius: 12px;
  background-color: #f7f9fc;
}

.row.align-items-center {
  display: flex;
  align-items: center;
}

.text-end {
  text-align: right;
}
</style>
